// extracted by mini-css-extract-plugin
module.exports = {"NewsList":"NewsList--2xl9X","header":"header--3p8g0","headerLeft":"headerLeft--vxzJK","headerRight":"headerRight--oiu0H","content":"content--TOWri"};